import React from 'react';
import SubNav from './SubNav';
import { useGetAllInspectionStatusesSuspense } from '../../../services/api/generated/client';
import { unwrapModel } from '../../../services/api/unwrapModel';
import { localise } from '../../../services/lang/lang';
import { DEFAULT_INSPECTION_LIST_STATUS, useInspectionListingContext, } from '../../pages/upgrade/InspectionListing/InspectionListingProvider';
import { PENDING } from '../../../constants/statuses';
import { useFeatureFlags } from '../../../context/FeatureFlagProvider';
const SidebarInspections = () => {
    const { canViewTeamInspections } = useInspectionListingContext();
    const { usePendingStatus } = useFeatureFlags();
    const { data: statusResponse } = useGetAllInspectionStatusesSuspense({
        query: { staleTime: Infinity },
    });
    const statuses = unwrapModel(statusResponse);
    if (!statuses)
        return null;
    const filteredStatuses = !usePendingStatus
        ? statuses.filter((status) => status.id !== PENDING)
        : statuses;
    const links = [
        {
            title: localise('MY_INSPECTIONS'),
            options: filteredStatuses.map((status) => ({
                to: `/inspections/my-inspections/${status.id}`,
                label: status.name,
                isDefault: status.id === DEFAULT_INSPECTION_LIST_STATUS,
            })),
        },
    ];
    if (canViewTeamInspections) {
        links.push({
            title: localise('TEAM_INSPECTIONS'),
            options: filteredStatuses.map((status) => ({
                to: `/inspections/team-inspections/${status.id}`,
                label: status.name,
            })),
        });
    }
    return React.createElement(SubNav, { rootPathName: "/inspections", links: links });
};
export default SidebarInspections;
